import { render } from "./MessageVue.vue?vue&type=template&id=68e3a240"
import script from "./MessageVue.vue?vue&type=script&lang=js"
export * from "./MessageVue.vue?vue&type=script&lang=js"

import "./MessageVue.vue?vue&type=style&index=0&id=68e3a240&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__